module.exports = __webpack_public_path__ + "static/img/4519_phase_function_Paper_PointsHejduk_Prediction.58e1747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4519_phase_function_Paper_PointsHejduk_Prediction.png
// module id = IQec
// module chunks = 0